import create from 'zustand';
import MediaService from '../../services/MediaService';

const VOLUME_KEY = 'song-share:volume';
const MUTE_KEY = 'song-share:muted';

const readNumber = (key: string, fallback: number): number => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    const parsed = Number(raw);
    if (Number.isNaN(parsed)) return fallback;
    return Math.min(1, Math.max(0, parsed));
  } catch {
    return fallback;
  }
};

const readBoolean = (key: string, fallback: boolean): boolean => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return raw === 'true';
  } catch {
    return fallback;
  }
};

const writeString = (key: string, value: string) => {
  try { localStorage.setItem(key, value); } catch { /* ignore */ }
};

export type PlayerState = {
  isPaused: boolean,
  isOver: boolean,
  volume: number,
  isMuted: boolean,
  isVolumeOpen: boolean,
  playNow: () => void,
  pauseNow: () => void,
  songIsOver: () => void,
  setVolume: (value: number) => void,
  toggleMute: () => void,
  setVolumeOpen: (open: boolean) => void,
}


export const usePlayer = create<PlayerState>((set, get) => ({
  isPaused: true,
  isOver: true,
  volume: readNumber(VOLUME_KEY, 1),
  isMuted: readBoolean(MUTE_KEY, false),
  isVolumeOpen: false,
  playNow: () => {
    set({ isPaused: false, isOver: false });
  },
  pauseNow: () => {
    set({ isPaused: true })
  },
  songIsOver: () => {
    set({ isOver: true })
  },
  setVolume: (value) => {
    const clamped = Math.min(1, Math.max(0, value));
    set({ volume: clamped, isMuted: false });
    writeString(VOLUME_KEY, String(clamped));
    writeString(MUTE_KEY, 'false');
    MediaService.please().setVolume(clamped);
  },
  toggleMute: () => {
    const next = !get().isMuted;
    set({ isMuted: next });
    writeString(MUTE_KEY, String(next));
    MediaService.please().setVolume(next ? 0 : get().volume);
  },
  setVolumeOpen: (open) => set({ isVolumeOpen: open }),
}));
